<template>
  <v-card class="image-card pa-2">
    <div class="video-iframe-container" v-if="isVideo">
      <iframe
        class="video-iframe"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        :src="image.video_url"
      ></iframe>
    </div>
    <v-img v-else :src="imageUrl" :lazy-src="imageUrlLowRes" contain> </v-img>
    <v-btn class="delete-btn" color="secondary" fab x-small @click="onDelete">
      <v-icon>mdi-trash-can-outline</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: 'ArtImage',
  props: {
    image: { type: Object },
  },
  computed: {
    imageUrl() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/870/${this.image.li_image_id}.jpg`
    },
    imageUrlLowRes() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/170/${this.image.li_image_id}.jpg`
    },
    isVideo() {
      return this.image.video_url
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.image)
    },
  },
}
</script>

<style lang="less" scoped>
.image-card {
  position: relative;
  cursor: move;
  .delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    opacity: 0;
  }
  &:hover .delete-btn {
    opacity: 1;
  }
}
</style>
